<nav id="navbar-container" class="navbar sticky-top navbar-expand-md navbar-dark d-flex justify-content-between align-items-center">
  <div [class.d-none]="searching">
    <button id="navbar-btn-toggle-sidebar" type="button" (click)="showSidebar()" class="btn menu-button sidebar-header size-mobile-button">
      <img src="{{urlAssets}}/icons/menu.png" alt="menu" class="size-mobile">
    </button>
    <img id="navbar-img-logo-equifax" src="{{urlAssets}}/images/logo-equifax.png" class="img-logo-equifax img-equifax-mobile" alt="image not found">
    <img id="navbar-img-logo-efx" src="{{urlAssets}}/images/logo-efx.svg" class="img-portfolio img-equifax-mobile" alt="image not found">
  </div>

  <ng-content select="[toggle-person-type-content]"></ng-content>

  <div id="navbar-container-brand-options" class="navbar-brand d-flex justify-content-between">
    <ng-content select="[extra-secondary-option]"></ng-content>
    <ng-content select="[extra-primary-option]"></ng-content>
  </div>
</nav>
